var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOutlineyoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "5296521_play_video_vlog_youtube_youtube logo_icon 18",
    clipPath: "url(#clip0_0_9573)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M13.7074 3.63039C13.5464 3.02801 13.0721 2.55368 12.4697 2.3927C11.3778 2.1001 6.99995 2.1001 6.99995 2.1001C6.99995 2.1001 2.62207 2.1001 1.53016 2.3927C0.92791 2.55368 0.453469 3.02801 0.292469 3.63039C0 4.72217 0 7.00013 0 7.00013C0 7.00013 0 9.27808 0.292469 10.3698C0.453469 10.9721 0.92791 11.4466 1.53016 11.6075C2.62207 11.9 6.99995 11.9 6.99995 11.9C6.99995 11.9 11.3778 11.9 12.4697 11.6075C13.0721 11.4466 13.5464 10.9721 13.7074 10.3698C14 9.27808 14 7.00013 14 7.00013C14 7.00013 14 4.72217 13.7074 3.63039Z",
    fill: "#ED1F24"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M5.59961 9.09996L9.23682 6.99993L5.59961 4.8999V9.09996Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_9573"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOutlineyoutube);
export default __webpack_public_path__ + "static/media/outlineyoutube.8eadb98630d2ad23393bb44571c96d53.svg";
export { ForwardRef as ReactComponent };